// extracted by mini-css-extract-plugin
export default {"fade_in":"Home_fade_in__lB1zf","fade-in":"Home_fade-in__reCqe"};